import React, { useState } from 'react';

// Import the editor components you've created
import MailerBagPDFEditor from '../components/MailerBag';
import HandTagsEditor from '../components/TagComponent';
import ThankYouCardEditor from '../components/ThankYouCard';
import StickerEditor from '../components/StickerComponent';
import Sidebar from '../components/Sidebar'; 
import Header from '../components/Header';
 

// --- Data for the Product Cards ---
const products = [
  {
    id: 'mailerBag',
    name: 'Custom Mailer Bags',
    description: 'Durable poly mailers for shipping your products in style.',
    features: ['Two sizes: 11"x14" & 13"x16"', 'Available in Black or White'],
    editorComponent: MailerBagPDFEditor,
    placeholderImage: (
      <img 
        src="/mailer-bag.jpg" 
        alt="Custom Mailer Bags" 
        className="w-full object-cover rounded-lg "
      />
    ),
  },
  {
    id: 'handTags',
    name: 'Hand Tags',
    description: 'High-quality cardstock tags to elevate your branding.',
    features: ['Standard size: 3.5" x 2"', 'Cost includes both front & back printing'],
    editorComponent: HandTagsEditor,
    placeholderImage: (
      <img 
        src="/hand-tags.jpg" 
        alt="Hand Tags" 
        className=" w-full object-cover rounded-lg"
      />
    ),
  },
  {
    id: 'thankYouCard',
    name: 'Thank You Cards',
    description: 'Show appreciation to your customers with a custom card.',
    features: ['Standard size: 6" x 3.5"', 'Single-sided printing'],
    editorComponent: ThankYouCardEditor,
    placeholderImage: (
      <img 
        src="/thank-you.jpg" 
        alt="Thank You Cards" 
        className="w-full object-cover rounded-lg"
      />
    ),
  },
  {
    id: 'stickers',
    name: 'Stickers',
    description: 'Durable, weather-resistant stickers for any surface.',
    features: ['Standard size: 2" x 2" Square', 'Quantity-based discounts available'],
    editorComponent: StickerEditor,
    placeholderImage: (
      <img 
        src="/stickers.jpg" 
        alt="Stickers" 
        className="w-full object-cover rounded-lg"
      />
    ),
  },
];

// --- Reusable Product Card Component ---
const ProductCard = ({ product, onSelect }) => {
  return (
    <div 
      onClick={() => onSelect(product.id)}
      className="bg-white rounded-xl shadow-md border border-slate-200 flex flex-col cursor-pointer 
                 transition-all duration-300 hover:shadow-xl hover:border-blue-500 hover:-translate-y-1"
    >
      <div className="bg-slate-50 rounded-t-xl my-8 p-4 h-48 flex items-center justify-center">
        {product.placeholderImage}
      </div>
      <div className="p-4 flex-grow flex flex-col">
        <h2 className="text-xl font-bold text-slate-800">{product.name}</h2>
        {/* <p className="mt-2 text-slate-600 text-sm flex-grow">{product.description}</p> */}
        <button className="mt-6 w-full bg-gray-900 text-white font-semibold py-2 rounded-lg hover:bg-gray-700 transition-colors">
          Customize
        </button>
      </div>
    </div>
  );
};


// --- Main Page Component ---
const ProductSelectorPage = () => {
  const [activeEditor, setActiveEditor] = useState(null);

  const handleSelectProduct = (productId) => {
    setActiveEditor(productId);
  };

  const handleGoBack = () => {
    setActiveEditor(null);
  };

  // Find the selected product to render its editor
  const SelectedEditor = products.find(p => p.id === activeEditor)?.editorComponent;
return (<>
    <Header />
  <div className="flex min-h-screen bg-slate-50">
    {/* Sidebar */}
    <div className="w-64 bg-white shadow-md border-r border-slate-200 z-10">
      <Sidebar />
    </div>

    {/* Main Content */}
    <div className="flex-1 overflow-y-auto">
      {SelectedEditor ? (
        <div className="relative h-full p-6">
          <button 
            onClick={handleGoBack}
            className="absolute top-4 left-4 z-20 flex items-center bg-white px-4 py-2 rounded-full shadow-lg border border-slate-200
                      text-slate-700 font-semibold hover:bg-slate-50 transition-colors"
          >
            <svg className="w-5 h-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M10 19l-7-7m0 0l7-7m-7 7h18"></path>
            </svg>
            Back to Products
          </button>
          <SelectedEditor />
        </div>
      ) : (
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
          <div className="text-center">
            <h1 className="text-4xl font-extrabold text-slate-900">Choose a Product to Customize</h1>
            <p className="mt-4 text-lg text-slate-600">
              Select from our range of customizable products to get started.
            </p>
          </div>

          <div className="mt-12 grid grid-cols-1 md:grid-cols-2 xl:grid-cols-4 gap-8 text-center">
            {products.map((product) => (
              <ProductCard 
                key={product.id} 
                product={product} 
                onSelect={handleSelectProduct}
              />
            ))}
          </div>
        </div>
      )}
    </div>
  </div>
  </>
);

};

export default ProductSelectorPage;

